import React from 'react';
import { CusProductListProductListProps } from '../../cus-product-list.data';
import ProductListItem from '../../components/product-list/item';
import ProductListItemSkeleton from './item-skeleton';
import usePromoBlocks from '../../hooks/usePromoBlocks';
import { PRIORITY_IMAGE_COUNT, PRODUCT_LIST_MODULE_NAME } from '../../cus-product-list.const';
import { useWishlist } from '../../../../shared/hooks/useWishlist';

export default function ProductList({ props, categoryProducts, mobileColumns, isLoading, itemsPerPage }: CusProductListProductListProps) {
    const { isProductInWishlist, toggleWishlist, isWishlistReady } = useWishlist(
        props.context,
        PRODUCT_LIST_MODULE_NAME,
        props.data.wishlists
    );
    const productsList = categoryProducts?.productList || [];
    const columnClass = mobileColumns === 1 ? ' bs-product-list-container--single-column' : '';

    const { repeat, startPosition, frequency } = props.config;
    const promoBlocks = props.slots?.promoBlocks;
    const { renderItems } = usePromoBlocks({
        repeat,
        startPosition,
        frequency,
        promoBlocks,
        products: productsList
    });

    if (isLoading) {
        return (
            <section className={`bs-product-list-container${columnClass}`} aria-busy={true} data-testid='plp-product-list'>
                {Array.from({ length: itemsPerPage }, (_, i) => (
                    <ProductListItemSkeleton key={i} />
                ))}
            </section>
        );
    }

    return (
        <section className={`bs-product-list-container${columnClass}`} aria-busy={false} data-testid='plp-product-list'>
            {renderItems.map(item => {
                if (item.kind === 'promo') {
                    return (
                        <div key={item.key} className='bs-product-list-container__promo-block'>
                            {item.promo}
                        </div>
                    );
                }

                const { product, index } = item;
                const { variant, colors } = product;
                if (!variant) {
                    return null;
                }
                const { imgUrl, basePriceFormatted, finalPriceFormatted, productPageUrl, concatenatedId, relewiseVariantId } = variant;
                const hasDiscountOrMemberPrice = variant.hasDiscount || !!variant.memberPriceData;
                return (
                    <ProductListItem
                        variantId={concatenatedId}
                        name={variant.displayName}
                        price={finalPriceFormatted}
                        listPrice={hasDiscountOrMemberPrice ? basePriceFormatted : undefined}
                        memberPrice={variant.memberPriceData}
                        src={imgUrl}
                        key={relewiseVariantId}
                        gridSettings={props.context.request.gridSettings!}
                        relativeUrl={productPageUrl}
                        colorVariants={colors}
                        labels={variant.labels}
                        isInWishlist={isProductInWishlist(variant.primarySizeVariant?.variantRecordId)}
                        onWishlistClick={() =>
                            toggleWishlist({
                                variantRecordId: variant.primarySizeVariant?.variantRecordId,
                                concatenatedId: variant.primarySizeVariant?.concatenatedId,
                                relewiseProductId: variant.relewiseProductId,
                                relewiseVariantId: variant.relewiseVariantId,
                                size: variant.primarySizeVariant?.size,
                                itemId: variant.productItemId,
                                variantDisplayName: variant.displayName,
                                color: variant.color.name,
                                discount: variant.discount,
                                price: variant.finalPrice,
                                brand: variant.brand
                            })
                        }
                        addToWishlistAriaLabel={props.resources.addToWishlistAriaLabel}
                        removeFromWishlistAriaLabel={props.resources.removeFromWishlistAriaLabel}
                        priority={index < PRIORITY_IMAGE_COUNT}
                        context={props.context}
                        isWishlistReady={isWishlistReady}
                    />
                );
            })}
        </section>
    );
}
